export enum TipoSolicitudComplementoEnum {
  ACM=1,
  DISCAPACIDAD=2,
  HIJASTRO=3,
  ESTADO_CIVIL=4
}
